
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingItemsDialog extends Serenity.EntityDialog<TreeMakingItemsRow, any> {
        protected getFormKey() { return TreeMakingItemsForm.formKey; }
        //protected getIdProperty() { return TreeMakingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return TreeMakingItemsRow.localTextPrefix; }
        //protected getNameProperty() { return TreeMakingItemsRow.nameProperty; }
        //protected getService() { return TreeMakingItemsService.baseUrl; }
        protected getDeletePermission() { return TreeMakingItemsRow.deletePermission; }
        protected getInsertPermission() { return TreeMakingItemsRow.insertPermission; }
        protected getUpdatePermission() { return TreeMakingItemsRow.updatePermission; }

        protected form = new TreeMakingItemsForm(this.idPrefix);

    }
}